import http from "../../http-common";

const validateAndRegister = (data) => {
  return http.post("/AccessHistory/ValidateAndRegister", data);
};

export default {
  validateAndRegister
};
